/**
 * GemPages & Smart Cart Drawer integration (V16)
 * -----------------------------------------------
 * Loaded once from the theme asset. No need for GemPages custom code blocks.
 *
 * 1. Intercepts GemPages/theme add-to-cart buttons.
 * 2. Adds subscription selling_plan when the pricing toggle is enabled.
 * 3. Uses Smart Cart Drawer Upsell's window.themeCartDrawer API when available.
 * 4. Keeps the clean iframe fetch bridge for Numod/Ghost fetch patch issues.
 * 5. Manages pricing toggle state across page navigation (localStorage).
 */
(function () {
    if (window._calmipetV16Active) return;
    window._calmipetV16Active = true;

    var DEBUG = false;

    function debugWarn() {
        if (!DEBUG || !window.console || !console.warn) return;
        try {
            console.warn.apply(console, arguments);
        } catch (e) {}
    }

    var SELLING_PLAN_ID = '692178714995';
    var TOGGLE_SELECTOR = '#pricingToggle';
    var ONE_TIME_SECTION_SELECTOR = '.grySPeG_VT';
    var SUBSCRIBE_SECTION_SELECTOR = '.gi_ryc1Smb';
    var _normalizedPath = (window.location.pathname || '').replace(/\/+$/, '') || '/';
    var TOGGLE_STORAGE_KEY = 'calmipet_toggle_v2_' + _normalizedPath;
    var SUB_VARIANT_IDS = ['62543605203315', '62543605236083', '62543605268851'];
    var ONE_TIME_TO_SUB_VARIANT_ID = {
        '62119469023603': '62543605203315',
        '62119469056371': '62543605236083',
        '62119469089139': '62543605268851'
    };
    var SMART_CART_TIMEOUT = 3000;
    var SMART_CART_ACTION_TIMEOUT = 4500;
    var CART_REQUEST_TIMEOUT = 9000;
    var CLEAN_FETCH_TIMEOUT = 1500;
    var KACHING_TRIGGER_READY_TIMEOUT = 4500;
    var KACHING_TRIGGER_TIMEOUT = 6500;
    var CART_DRAWER_INTERNAL_HEADER = 'X-Cart-Drawer-Source';
    var CHECKOUT_RETURN_MARKER_KEY = 'calmipet_checkout_bridge_return_pending_v1';
    var META_PIXEL_ID = '1937618546905939';
    var _preferDirectCartAdd = false;
    var _upsellProductCache = {};
    var _kachingCheckoutBridge = {
        armed: false,
        redirecting: false,
        listenersBound: false,
        timeoutId: null,
        expiresAt: 0
    };

    function withTimeout(promise, timeout, label) {
        var timeoutId;
        return new Promise(function (resolve, reject) {
            timeoutId = setTimeout(function () {
                reject(new Error((label || 'Async task') + ' timed out'));
            }, timeout);
            Promise.resolve(promise).then(function (value) {
                clearTimeout(timeoutId);
                resolve(value);
            }).catch(function (err) {
                clearTimeout(timeoutId);
                reject(err);
            });
        });
    }

    function resetCleanFetch() {
        var currentIframe = document.getElementById('__cleanFetch');
        if (currentIframe && currentIframe.parentNode) {
            currentIframe.parentNode.removeChild(currentIframe);
        }
    }

    // ---- CLEAN FETCH BRIDGE (Ghost Patcher Bypass) ----
    function getFetch() {
        return new Promise(function (resolve) {
            var done = false;
            var fallbackTimer = setTimeout(function () {
                if (done) return;
                done = true;
                resolve(window.fetch.bind(window));
            }, CLEAN_FETCH_TIMEOUT);

            function finish(fetchFn) {
                if (done) return;
                done = true;
                clearTimeout(fallbackTimer);
                resolve(fetchFn);
            }

            var check = function () {
                if (done) return;
                var mountTarget = document.body || document.documentElement;
                if (!mountTarget) {
                    setTimeout(check, 100);
                    return;
                }

                var currentIframe = document.getElementById('__cleanFetch');
                if (!currentIframe || !currentIframe.contentWindow) {
                    if (currentIframe && currentIframe.parentNode) currentIframe.parentNode.removeChild(currentIframe);
                    currentIframe = document.createElement('iframe');
                    currentIframe.id = '__cleanFetch';
                    currentIframe.style.display = 'none';
                    mountTarget.appendChild(currentIframe);
                }

                if (currentIframe.contentWindow && currentIframe.contentWindow.fetch) {
                    finish(currentIframe.contentWindow.fetch.bind(currentIframe.contentWindow));
                } else {
                    setTimeout(check, 100);
                }
            };
            check();
        });
    }

    async function fetchWithTimeout(fetchFn, url, options, timeout, label) {
        options = Object.assign({}, options || {});
        var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var abortTimer = null;
        if (controller) {
            options.signal = controller.signal;
            abortTimer = setTimeout(function () {
                try { controller.abort(); } catch (e) { /* already settled */ }
            }, timeout);
        }
        try {
            return await withTimeout(fetchFn(url, options), timeout + 500, label || 'Cart request');
        } finally {
            if (abortTimer) clearTimeout(abortTimer);
        }
    }

    // ---- GLOBAL FETCH PROXY KALDIRILDI ----
    // npix passive hooks modunda çalışıyor (askıya almıyor), SCD da kendi
    // wrapper'ını koymuş. Proxy kurmak SCD'nin fetch interceptor zincirini
    // bozuyor ve sayfa açılışında drawer'ı tetikliyor olabilir.
    //
    // window.fetch'e dokunmuyoruz. Clean fetch sadece BUY NOW akışında,
    // doğrudan getFetch() üzerinden manuel kullanılır.

    function isSmartCartAvailable() {
        return !!(window.themeCartDrawer && typeof window.themeCartDrawer.open === 'function');
    }

    function hasSmartCartEmbed() {
        return !!(
            document.querySelector('[data-cart-drawer-auto-init]') ||
            document.getElementById('cart-drawer-container') ||
            document.getElementById('cart-drawer-shadow-host') ||
            window.CartDrawerConfig
        );
    }

    function waitForSmartCart(timeout) {
        timeout = typeof timeout === 'number' ? timeout : SMART_CART_TIMEOUT;
        return new Promise(function (resolve) {
            if (isSmartCartAvailable()) {
                resolve(window.themeCartDrawer);
                return;
            }
            var startedAt = Date.now();
            var timer = setInterval(function () {
                if (isSmartCartAvailable()) {
                    clearInterval(timer);
                    resolve(window.themeCartDrawer);
                    return;
                }
                if (Date.now() - startedAt >= timeout) {
                    clearInterval(timer);
                    resolve(null);
                }
            }, 50);
        });
    }

    function getQuantity(form) {
        var input = form && form.querySelector('input[name="quantity"], select[name="quantity"]');
        var qty = input && input.value ? parseInt(input.value, 10) : 1;
        return Number.isFinite(qty) && qty > 0 ? qty : 1;
    }

    function getLineItemProperties(form) {
        var properties = {};
        if (!form) return properties;
        var fields = form.querySelectorAll('[name^="properties["]');
        fields.forEach(function (field) {
            var match = field.name.match(/^properties\[(.+)\]$/);
            if (!match || field.disabled) return;
            if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
            if (field.value == null || field.value === '') return;
            properties[match[1]] = field.value;
        });
        return properties;
    }

    function isSubscriptionSelected() {
        return !!document.querySelector(TOGGLE_SELECTOR + ':checked');
    }

    // ---- TOGGLE STATE PERSISTENCE & SECTION VISIBILITY ----
    var _toggleRestoreInProgress = false;
    var _toggleObserver = null;
    var _toggleObserverDebounce = null;
    var _lastBoundToggle = null;

    function saveToggleState() {
        try {
            var toggle = document.querySelector(TOGGLE_SELECTOR);
            if (!toggle) return;
            if (_toggleRestoreInProgress) return;
            localStorage.setItem(TOGGLE_STORAGE_KEY, toggle.checked ? '1' : '0');
        } catch (e) { /* private mode / quota */ }
    }

    function applyToggleSections(isSubscribed) {
        var oneTimeSections = document.querySelectorAll(ONE_TIME_SECTION_SELECTOR);
        var subscribeSections = document.querySelectorAll(SUBSCRIBE_SECTION_SELECTOR);
        if (!oneTimeSections.length && !subscribeSections.length) return;

        var toHide = isSubscribed ? oneTimeSections : subscribeSections;
        var toShow = isSubscribed ? subscribeSections : oneTimeSections;

        toHide.forEach(function (el) {
            el.classList.add('gp-toggle-hidden');
            el.classList.remove('gp-toggle-fade-in');
        });

        toShow.forEach(function (el) {
            el.classList.remove('gp-toggle-hidden');
            if (el.style && el.style.display === 'none') el.style.display = '';
            el.classList.remove('gp-toggle-fade-in');
            void el.offsetWidth;
            el.classList.add('gp-toggle-fade-in');
        });
    }

    function restoreAndApplyToggle(toggle) {
        if (!toggle) toggle = document.querySelector(TOGGLE_SELECTOR);
        if (!toggle) return;

        try {
            var saved = localStorage.getItem(TOGGLE_STORAGE_KEY);
            if (saved !== null) {
                var shouldCheck = saved === '1';
                if (toggle.checked !== shouldCheck) {
                    _toggleRestoreInProgress = true;
                    toggle.checked = shouldCheck;
                    // change/input event DISPATCH ETMİYORUZ — başka bundle'ları
                    // tetikleyip drawer açma riski var. Section visibility'yi
                    // doğrudan applyToggleSections ile zaten uyguluyoruz.
                    setTimeout(function () { _toggleRestoreInProgress = false; }, 50);
                }
            }
        } catch (e) { /* private mode */ }

        applyToggleSections(toggle.checked);
    }

    document.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches(TOGGLE_SELECTOR)) {
            _preferDirectCartAdd = true;
            resetLoadingButtons();
            resetCleanFetch();
            if (!_toggleRestoreInProgress) {
                saveToggleState();
            }
            applyToggleSections(e.target.checked);
        }
    }, false);

    function initToggleSections() {
        var toggle = document.querySelector(TOGGLE_SELECTOR);
        if (toggle && toggle !== _lastBoundToggle) {
            _lastBoundToggle = toggle;
            restoreAndApplyToggle(toggle);
        }

        if (_toggleObserver) return;
        var observeTarget = document.body || document.documentElement;
        if (!observeTarget) return;

        _toggleObserver = new MutationObserver(function () {
            if (_toggleObserverDebounce) return;
            _toggleObserverDebounce = setTimeout(function () {
                _toggleObserverDebounce = null;
                var current = document.querySelector(TOGGLE_SELECTOR);
                if (current && current !== _lastBoundToggle) {
                    _lastBoundToggle = current;
                    restoreAndApplyToggle(current);
                }
            }, 100);
        });
        _toggleObserver.observe(observeTarget, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initToggleSections, { once: true });
    } else {
        initToggleSections();
    }

    function normalizeVariantIdForSelection(variantId) {
        var id = String(variantId);
        if (isSubscriptionSelected() && ONE_TIME_TO_SUB_VARIANT_ID[id]) {
            return ONE_TIME_TO_SUB_VARIANT_ID[id];
        }
        return id;
    }

    function shouldApplySellingPlan(variantId) {
        return SUB_VARIANT_IDS.indexOf(String(variantId)) !== -1;
    }

    function buildAddPayload(variantId, quantity, properties) {
        var selectedVariantId = normalizeVariantIdForSelection(variantId);
        var payload = {
            id: parseInt(selectedVariantId, 10),
            quantity: quantity || 1
        };
        if (properties && Object.keys(properties).length > 0) {
            payload.properties = properties;
        }
        if (shouldApplySellingPlan(selectedVariantId)) {
            payload.selling_plan = parseInt(SELLING_PLAN_ID, 10);
        }
        return payload;
    }

    function normalizeText(value) {
        return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
    }

    function sleep(ms) {
        return new Promise(function (resolve) {
            setTimeout(resolve, ms);
        });
    }

    function isElementNode(node) {
        return !!(node && node.nodeType === 1);
    }

    function getElementLabel(el) {
        if (!el) return '';
        return normalizeText(
            (el.innerText || el.textContent || '') + ' ' +
            (el.getAttribute && (
                el.getAttribute('aria-label') ||
                el.getAttribute('name') ||
                el.getAttribute('value') ||
                ''
            ) || '')
        );
    }

    function isCheckoutUrl(value) {
        if (!value) return false;
        try {
            var url = new URL(value, window.location.origin);
            return url.pathname === '/checkout' || url.pathname.indexOf('/checkout/') === 0;
        } catch (e) {
            return String(value).indexOf('/checkout') !== -1;
        }
    }

    function getCartDrawerSettings() {
        return (window.cartDrawerSettings && window.cartDrawerSettings.upsell) ||
            (window.cartDrawerSettings && window.cartDrawerSettings.settings && window.cartDrawerSettings.settings.upsell) ||
            (window.CartDrawerConfig && window.CartDrawerConfig.settings && window.CartDrawerConfig.settings.upsell) ||
            null;
    }

    function filterUpsellHandles(handles) {
        var seen = {};
        return (Array.isArray(handles) ? handles : []).filter(function (handle) {
            if (typeof handle !== 'string') return false;
            handle = handle.trim();
            if (!handle || seen[handle]) return false;
            seen[handle] = true;
            return true;
        });
    }

    function getEmbeddedUpsellHandles() {
        var scripts = document.querySelectorAll('script');
        for (var i = 0; i < scripts.length; i += 1) {
            var text = scripts[i].textContent || '';
            if (text.indexOf('selectedProductHandles') === -1) continue;
            var match = text.match(/["']?selectedProductHandles["']?\s*:\s*(\[[^\]]*\])/);
            if (!match) continue;
            try {
                var handles = JSON.parse(match[1]);
                handles = filterUpsellHandles(handles);
                if (handles.length) return handles;
            } catch (err) {
                debugWarn('Upsell handle parse failed:', err);
            }
        }
        return [];
    }

    function getUpsellHandles() {
        var settings = getCartDrawerSettings();
        var handles = settings && Array.isArray(settings.selectedProductHandles) ? settings.selectedProductHandles : [];
        handles = filterUpsellHandles(handles);
        return handles.length ? handles : getEmbeddedUpsellHandles();
    }

    function getAvailableVariant(product) {
        if (!product || !Array.isArray(product.variants)) return null;
        return product.variants.find(function (variant) {
            return variant && (
                variant.available === true ||
                variant.availableForSale === true ||
                (typeof variant.inventoryQuantity === 'number' && variant.inventoryQuantity > 0) ||
                (typeof variant.inventory_quantity === 'number' && variant.inventory_quantity > 0)
            );
        }) || product.variants[0] || null;
    }

    async function fetchUpsellProduct(fetchFn, handle) {
        if (!handle) return null;
        if (_upsellProductCache[handle]) return _upsellProductCache[handle];
        try {
            var res = await fetchWithTimeout(fetchFn || window.fetch.bind(window), window.location.origin + '/products/' + encodeURIComponent(handle) + '.js?_=' + Date.now(), {
                method: 'GET',
                headers: { 'Accept': 'application/json' }
            }, CART_REQUEST_TIMEOUT, 'Upsell product fetch');
            if (!res.ok) return null;
            var product = await withTimeout(res.json(), 2000, 'Upsell product JSON');
            if (product && Array.isArray(product.variants)) {
                _upsellProductCache[handle] = product;
                return product;
            }
        } catch (err) {
            debugWarn('Upsell product fetch failed:', err);
        }
        return null;
    }

    async function resolveUpsellVariant(button, fetchFn) {
        if (!button) return null;
        var directId = button.getAttribute('data-variant-id') || button.getAttribute('data-product-variant');
        if (directId) return directId;

        var card = button.closest('.upsell-product-card') || button.closest('.upsell-carousel-container');
        var title = card && card.querySelector ? normalizeText((card.querySelector('.upsell-product-title') || {}).textContent) : '';
        var handles = getUpsellHandles();
        var fallbackVariant = null;

        for (var i = 0; i < handles.length; i += 1) {
            var product = await fetchUpsellProduct(fetchFn, handles[i]);
            var variant = getAvailableVariant(product);
            if (!variant) continue;
            if (!fallbackVariant) fallbackVariant = variant;
            if (title && normalizeText(product.title) === title) return variant.id;
        }

        return fallbackVariant && fallbackVariant.id ? fallbackVariant.id : null;
    }

    function getSmartCartUpsellButton(event) {
        var path = event && typeof event.composedPath === 'function' ? event.composedPath() : [];
        var insideDrawer = false;
        var button = null;

        for (var i = 0; i < path.length; i += 1) {
            var node = path[i];
            if (!node) continue;
            if (node.id === 'cart-drawer-shadow-host' || node.id === 'cart-drawer-container') insideDrawer = true;
            if (!button && node.classList && node.classList.contains('upsell-add-button')) button = node;
        }

        if (!insideDrawer || !button) return null;
        return button;
    }

    function getSmartCartCheckoutButton(event) {
        var path = event && typeof event.composedPath === 'function' ? event.composedPath() : [];
        var insideDrawer = false;
        var checkoutButton = null;

        for (var i = 0; i < path.length; i += 1) {
            var node = path[i];
            if (!node) continue;
            if (node.id === 'cart-drawer-shadow-host' || node.id === 'cart-drawer-container') {
                insideDrawer = true;
            }
            if (node.tagName && /cart-drawer/i.test(node.tagName)) {
                insideDrawer = true;
            }
            if (checkoutButton || !isElementNode(node)) continue;

            var tagName = String(node.tagName || '').toLowerCase();
            var role = node.getAttribute && normalizeText(node.getAttribute('role'));
            var isInteractive = tagName === 'button' || tagName === 'a' || tagName === 'input' || role === 'button';
            if (!isInteractive) continue;

            var name = node.getAttribute && normalizeText(node.getAttribute('name'));
            var href = node.getAttribute && (node.getAttribute('href') || node.href);
            var label = getElementLabel(node);
            var hasCheckoutMarker = node.hasAttribute && node.hasAttribute('data-cart-checkout');

            if (
                name === 'checkout' ||
                hasCheckoutMarker ||
                isCheckoutUrl(href) ||
                /\b(proceed to checkout|checkout|check out)\b/i.test(label)
            ) {
                checkoutButton = node;
            }
        }

        return insideDrawer ? checkoutButton : null;
    }

    async function addSmartCartUpsellDirect(button) {
        if (!button || button.disabled || button.getAttribute('data-clm-upsell-loading') === '1') return;

        var originalText = button.textContent;
        button.setAttribute('data-clm-upsell-loading', '1');
        button.disabled = true;
        button.textContent = 'Adding...';

        try {
            var fetchBridge = await getFetch();
            var variantId = await resolveUpsellVariant(button, fetchBridge);
            if (!variantId) throw new Error('Smart Cart upsell variant could not be resolved');

            var payload = buildAddPayload(variantId, 1, { _added_via_upsell: '1' });
            var headers = {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            };
            headers[CART_DRAWER_INTERNAL_HEADER] = 'internal';

            var res = await fetchWithTimeout(fetchBridge, window.location.origin + '/cart/add.js', {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload)
            }, CART_REQUEST_TIMEOUT, 'Upsell cart add');

            if (!res.ok) throw new Error('Smart Cart upsell add failed');
            var addedItem = await withTimeout(res.json(), 2000, 'Upsell cart add JSON');
            trackMetaAddToCart(addedItem, variantId, 1);
            await syncAfterDirectAdd(fetchBridge);
        } catch (err) {
            console.error('Smart Cart upsell add failed:', err);
            scheduleCartOpenRecovery();
        } finally {
            button.disabled = false;
            button.removeAttribute('data-clm-upsell-loading');
            button.textContent = originalText || 'Add to Cart';
        }
    }

    function getCartItemCount(cartData) {
        if (!cartData) return null;
        if (typeof cartData.item_count === 'number') {
            return cartData.item_count;
        }
        if (Array.isArray(cartData.items)) {
            return cartData.items.reduce(function (total, item) {
                return total + (parseInt(item.quantity, 10) || 0);
            }, 0);
        }
        if (Array.isArray(cartData)) {
            return cartData.reduce(function (total, item) {
                return total + (parseInt(item.quantity, 10) || 0);
            }, 0);
        }
        return null;
    }

    function isFullCartPayload(cartData) {
        return !!(cartData && typeof cartData.item_count === 'number' && Array.isArray(cartData.items));
    }

    function setCartIconCount(count) {
        count = Math.max(0, parseInt(count, 10) || 0);
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = String(count);
            el.setAttribute('data-cart-count', String(count));
        });
        document.querySelectorAll('.cart-bubble').forEach(function (bubble) {
            bubble.classList.toggle('visually-hidden', count === 0);
            bubble.setAttribute('aria-hidden', count === 0 ? 'true' : 'false');
        });
        document.querySelectorAll('.cart-bubble__text-count, [data-testid="cart-bubble"]').forEach(function (el) {
            el.textContent = String(count);
            el.classList.toggle('hidden', count === 0);
        });
        document.querySelectorAll('.cart-bubble__text .visually-hidden').forEach(function (el) {
            el.textContent = 'Total items in cart: ' + count;
        });
        document.querySelectorAll('a.header-actions__action.action__cart, a[href="/cart"][aria-label]').forEach(function (link) {
            var label = link.getAttribute('aria-label') || 'Cart';
            label = label.replace(/Total items in cart:\s*\d+/i, '').replace(/\s+/g, ' ').trim();
            link.setAttribute('aria-label', label + ' Total items in cart: ' + count);
        });
    }

    function refreshCartIconCount(cartData) {
        var count = getCartItemCount(cartData);
        if (count != null) {
            setCartIconCount(count);
            return Promise.resolve(count);
        }
        return new Promise(function (resolve) {
            try {
                var settled = false;
                var xhr = new XMLHttpRequest();
                var timer = setTimeout(function () {
                    if (settled) return;
                    settled = true;
                    try { xhr.abort(); } catch (e) { /* already done */ }
                    resolve(null);
                }, CART_REQUEST_TIMEOUT);
                function finish(value) {
                    if (settled) return;
                    settled = true;
                    clearTimeout(timer);
                    resolve(value);
                }
                xhr.open('GET', '/cart.js?_=' + Date.now(), true);
                xhr.setRequestHeader('Accept', 'application/json');
                xhr.onload = function () {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            var cart = JSON.parse(xhr.responseText);
                            count = getCartItemCount(cart);
                            if (count != null) setCartIconCount(count);
                            finish(count);
                        } catch (e) { finish(null); }
                    } else { finish(null); }
                };
                xhr.onerror = function () { finish(null); };
                xhr.send();
            } catch (err) {
                resolve(null);
            }
        });
    }

    function dispatchCartEvents(cartData, source, skipUI) {
        var isFullCart = isFullCartPayload(cartData);
        var detail = {
            resource: cartData,
            sourceId: 'gp-smart-cart-v16',
            data: { source: source || 'cart-add', sections: (cartData && cartData.sections) || {} }
        };

        if (!skipUI && isFullCart) {
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detail }));
            document.dispatchEvent(new CustomEvent('shopify:cart:update', { bubbles: true, detail: { cart: cartData } }));
            document.dispatchEvent(new CustomEvent('shopify:cart:change', { bubbles: true, detail: { cart: cartData } }));
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cartData } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cartData } }));
        }

        refreshCartIconCount(cartData);
    }

    function getShopifyCurrency() {
        return (
            (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.currency) ||
            (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
            'USD'
        );
    }

    function canTrackMarketing() {
        try {
            var privacy = window.Shopify && window.Shopify.customerPrivacy;
            if (!privacy) return true;
            if (typeof privacy.marketingAllowed === 'function') return privacy.marketingAllowed();
            if (typeof privacy.userCanBeTracked === 'function') return privacy.userCanBeTracked();
        } catch (e) {}
        return true;
    }

    function toMoneyValue(cents) {
        var value = Number(cents);
        if (!Number.isFinite(value) || value <= 0) return null;
        return Math.round((value / 100) * 100) / 100;
    }

    function getAddedItemVariantId(addedItem, fallbackVariantId) {
        return String(
            (addedItem && (addedItem.variant_id || addedItem.id)) ||
            fallbackVariantId ||
            ''
        );
    }

    function getAddedItemQuantity(addedItem, fallbackQuantity) {
        var quantity = parseInt((addedItem && addedItem.quantity) || fallbackQuantity || 1, 10);
        return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    function getMetaContentId(addedItem, variantId) {
        var productId = addedItem && addedItem.product_id ? String(addedItem.product_id) : '';
        var selectedVariantId = variantId ? String(variantId) : '';
        if (productId && selectedVariantId) return 'shopify_US_' + productId + '_' + selectedVariantId;
        return selectedVariantId || productId;
    }

    function getCookieValue(name) {
        try {
            var parts = document.cookie ? document.cookie.split(';') : [];
            for (var i = 0; i < parts.length; i += 1) {
                var part = parts[i].trim();
                if (part.indexOf(name + '=') === 0) return decodeURIComponent(part.slice(name.length + 1));
            }
        } catch (e) {}
        return '';
    }

    function appendMetaParam(params, key, value) {
        if (value == null || value === '') return;
        params.append(key, String(value));
    }

    function sendMetaAddToCartBeacon(payload, eventId) {
        if (!META_PIXEL_ID || !canTrackMarketing()) return;

        try {
            var params = new URLSearchParams();
            appendMetaParam(params, 'id', META_PIXEL_ID);
            appendMetaParam(params, 'ev', 'AddToCart');
            appendMetaParam(params, 'dl', window.location.href);
            appendMetaParam(params, 'rl', document.referrer || '');
            appendMetaParam(params, 'if', 'false');
            appendMetaParam(params, 'ts', Date.now());
            appendMetaParam(params, 'v', '2.9');
            appendMetaParam(params, 'r', 'stable');
            appendMetaParam(params, 'eid', eventId);
            appendMetaParam(params, 'fbp', getCookieValue('_fbp'));
            appendMetaParam(params, 'fbc', getCookieValue('_fbc'));
            appendMetaParam(params, 'cd[content_type]', payload.content_type);
            appendMetaParam(params, 'cd[content_ids]', JSON.stringify(payload.content_ids || []));
            appendMetaParam(params, 'cd[contents]', JSON.stringify(payload.contents || []));
            appendMetaParam(params, 'cd[currency]', payload.currency);
            appendMetaParam(params, 'cd[value]', payload.value);
            appendMetaParam(params, 'cd[content_name]', payload.content_name);

            var beacon = new Image();
            window._calmipetMetaBeaconImages = window._calmipetMetaBeaconImages || [];
            window._calmipetMetaBeaconImages.push(beacon);
            beacon.src = 'https://www.facebook.com/tr/?' + params.toString();
            window._calmipetLastMetaAddToCartBeacon = beacon.src;
        } catch (err) {
            debugWarn('Meta AddToCart beacon failed:', err);
        }
    }

    function trackMetaAddToCart(addedItem, fallbackVariantId, fallbackQuantity) {
        var variantId = getAddedItemVariantId(addedItem, fallbackVariantId);
        var quantity = getAddedItemQuantity(addedItem, fallbackQuantity);
        var contentId = getMetaContentId(addedItem, variantId);
        if (!contentId) return;

        var lineValue = toMoneyValue(addedItem && (addedItem.final_line_price || addedItem.line_price));
        var unitValue = toMoneyValue(addedItem && (addedItem.final_price || addedItem.price));
        var value = lineValue || (unitValue ? Math.round(unitValue * quantity * 100) / 100 : null);
        var payload = {
            content_type: 'product',
            content_ids: [contentId],
            contents: [{ id: contentId, quantity: quantity }],
            currency: getShopifyCurrency()
        };

        if (value != null) payload.value = value;
        if (unitValue != null) payload.contents[0].item_price = unitValue;
        if (addedItem && addedItem.product_title) payload.content_name = addedItem.product_title;

        var eventId = 'clm_atc_' + Date.now() + '_' + Math.random().toString(36).slice(2);

        // 2026-07-23: beacon disabled — it duplicated the AddToCart already sent by
        // Shopify's native Facebook & Instagram channel pixel (different event IDs,
        // so Meta could not dedupe and every ATC counted twice). Cart-drawer sync
        // behavior below is unchanged.
        // sendMetaAddToCartBeacon(payload, eventId);
        document.dispatchEvent(new CustomEvent('calmipet:meta-add-to-cart', {
            bubbles: true,
            detail: { eventID: eventId, payload: payload }
        }));
    }

    async function fetchFullCart(fetchFn) {
        try {
            var selectedFetch = fetchFn || window.fetch.bind(window);
            var res = await fetchWithTimeout(selectedFetch, window.location.origin + '/cart.js?_=' + Date.now(), {
                method: 'GET',
                headers: { 'Accept': 'application/json' }
            }, CART_REQUEST_TIMEOUT, 'Full cart fetch');
            if (!res.ok) return null;
            var cart = await withTimeout(res.json(), 2000, 'Full cart JSON');
            return isFullCartPayload(cart) ? cart : null;
        } catch (err) {
            debugWarn('Full cart fetch failed after add:', err);
            return null;
        }
    }

    async function syncAfterDirectAdd(fetchFn) {
        var fullCart = await fetchFullCart(fetchFn);
        if (fullCart) {
            dispatchCartEvents(fullCart, 'cart-add');
        } else {
            refreshCartIconCount();
        }
        scheduleCartOpen();
    }

    function openNativeCartFallback() {
        var selectors = [
            '[data-cart-trigger]',
            '.cart-trigger',
            '.cart-icon',
            '.cart-link',
            '.header__icon--cart',
            '.header-actions__action[data-open-drawer]',
            'button[aria-controls="cart-drawer"]',
            'a[href="/cart"]'
        ];
        for (var i = 0; i < selectors.length; i += 1) {
            var trigger = document.querySelector(selectors[i]);
            if (trigger) {
                trigger.click();
                return true;
            }
        }
        return false;
    }

    async function syncAndOpenCart() {
        var drawer = await waitForSmartCart(hasSmartCartEmbed() ? SMART_CART_TIMEOUT : 250);
        if (drawer) {
            try {
                if (typeof drawer.syncWithShopifyCart === 'function') {
                    await withTimeout(drawer.syncWithShopifyCart(true), SMART_CART_ACTION_TIMEOUT, 'Smart Cart sync');
                }
            } catch (err) {
                debugWarn('Smart Cart sync failed before open:', err);
            }
            try {
                drawer.open();
                return true;
            } catch (err2) {
                debugWarn('Smart Cart open failed:', err2);
            }
        }
        return openNativeCartFallback();
    }

    function isCartDrawerOpen() {
        if (document.body && document.body.classList.contains('cart-drawer-open')) return true;
        var host = document.getElementById('cart-drawer-shadow-host');
        if (!host) return false;
        try {
            var root = host.shadowRoot;
            if (!root) return false;
            var closeButton = root.querySelector('button[aria-label="Close cart"], .cart-close-btn');
            if (!closeButton) return false;
            var rect = closeButton.getBoundingClientRect();
            var style = window.getComputedStyle(closeButton);
            return rect.width > 0 && rect.height > 0 &&
                style.display !== 'none' &&
                style.visibility !== 'hidden' &&
                style.opacity !== '0';
        } catch (e) {
            return false;
        }
    }

    function scheduleCartOpen() {
        syncAndOpenCart().catch(function (err) {
            debugWarn('Smart Cart open after add failed:', err);
        });
        setTimeout(function () {
            if (document.visibilityState === 'hidden' || isCartDrawerOpen()) return;
            syncAndOpenCart().catch(function (err) {
                debugWarn('Smart Cart retry open after add failed:', err);
            });
        }, 700);
    }

    function scheduleCartOpenRecovery() {
        refreshCartIconCount();
        scheduleCartOpen();
        setTimeout(scheduleCartOpen, 1200);
    }

    async function addWithSmartCart(variantId, quantity, properties) {
        if (_preferDirectCartAdd) return null;
        var drawer = await waitForSmartCart(hasSmartCartEmbed() ? SMART_CART_TIMEOUT : 0);
        if (!drawer || typeof drawer.addItem !== 'function') return null;
        var selectedVariantId = normalizeVariantIdForSelection(variantId);
        if (shouldApplySellingPlan(selectedVariantId)) return null;
        var numericVariantId = parseInt(selectedVariantId, 10);
        var drawerVariantId = Number.isFinite(numericVariantId) ? numericVariantId : selectedVariantId;
        var result;
        try {
            result = await withTimeout(
                drawer.addItem(drawerVariantId, quantity || 1, properties || {}),
                SMART_CART_ACTION_TIMEOUT,
                'Smart Cart addItem'
            );
        } catch (err) {
            debugWarn('Smart Cart addItem failed, falling back to direct cart add:', err);
            return null;
        }
        if (result && result.success === false) return null;
        await refreshCartIconCount();
        return result || { success: true };
    }

    async function addWithCleanFetch(variantId, quantity, properties) {
        try {
            var fetchBridge = await getFetch();
            var payload = buildAddPayload(variantId, quantity, properties);
            var res = await fetchWithTimeout(fetchBridge, window.location.origin + '/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(payload)
            }, CART_REQUEST_TIMEOUT, 'Clean cart add');
            if (!res.ok) return null;
            var data = await withTimeout(res.json(), 2000, 'Clean cart add JSON');
            await syncAfterDirectAdd(fetchBridge);
            return data;
        } catch (err) {
            debugWarn('Clean cart add failed, falling back to window.fetch:', err);
            return null;
        }
    }

    function resetLoadingButtons() {
        document.querySelectorAll('button.gp-button-atc[data-state="loading"], button[type="submit"][name="add"][data-state="loading"]').forEach(function (button) {
            button.setAttribute('data-state', 'idle');
        });
        document.querySelectorAll('[data-clm-checkout-loading], [data-clm-upsell-loading]').forEach(function (button) {
            button.removeAttribute('data-clm-checkout-loading');
            button.removeAttribute('data-clm-upsell-loading');
        });
    }

    function restoreToggleAfterNavigation() {
        _lastBoundToggle = null;
        initToggleSections();
        var attempts = 0;
        var retry = setInterval(function () {
            attempts++;
            var toggle = document.querySelector(TOGGLE_SELECTOR);
            if (toggle) {
                _lastBoundToggle = toggle;
                restoreAndApplyToggle(toggle);
                clearInterval(retry);
            } else if (attempts > 30) {
                clearInterval(retry);
            }
        }, 150);
    }

    function performPageRestoreCleanup(reason) {
        _preferDirectCartAdd = true;
        _kachingCheckoutBridge.redirecting = false;
        disarmKachingCheckoutBridge();
        resetCleanFetch();
        resetLoadingButtons();
        resetKachingPopupAfterReturn();
        try {
            if (window.themeCartDrawer && typeof window.themeCartDrawer.close === 'function') {
                window.themeCartDrawer.close();
            }
        } catch (e) { /* drawer may already be gone */ }
        if (document.body) {
            document.body.classList.remove('cart-drawer-open');
        }
        restoreToggleAfterNavigation();
        refreshCartIconCount();
        [160, 700, 1400].forEach(function (delay) {
            setTimeout(function () {
                resetLoadingButtons();
                resetKachingPopupAfterReturn();
                refreshCartIconCount();
            }, delay);
        });
    }

    function resetKachingPopupAfterReturn() {
        clearKachingPopupSuppression();

        if (document.body) {
            document.body.classList.remove('kaching-popup-open');
        }

        document.querySelectorAll('.kaching-overlay').forEach(function (overlay) {
            try {
                overlay.classList.remove('kaching-popup-visible');
                overlay.style.setProperty('display', 'none', 'important');
                overlay.style.setProperty('opacity', '0', 'important');
                overlay.style.setProperty('visibility', 'hidden', 'important');
                overlay.style.setProperty('pointer-events', 'none', 'important');
            } catch (e) { /* Kaching may replace the node during restore */ }
        });

        document.querySelectorAll('.kaching-popup').forEach(function (popup) {
            try {
                popup.style.setProperty('opacity', '0', 'important');
                popup.style.setProperty('visibility', 'hidden', 'important');
                popup.style.setProperty('pointer-events', 'none', 'important');
            } catch (e2) { /* Kaching may replace the node during restore */ }
        });

        var v2Popup = document.querySelector('kaching-popup-v2');
        if (v2Popup && typeof v2Popup.close === 'function') {
            try { v2Popup.close(); } catch (e3) { /* optional API */ }
        }
    }

    function isElementActuallyVisible(el) {
        if (!el) return false;
        try {
            var rect = el.getBoundingClientRect();
            var style = window.getComputedStyle(el);
            return rect.width > 0 &&
                rect.height > 0 &&
                style.display !== 'none' &&
                style.visibility !== 'hidden' &&
                style.opacity !== '0';
        } catch (e) {
            return false;
        }
    }

    function isKachingPopupVisible() {
        var visibleOverlay = document.querySelector('.kaching-overlay.kaching-popup-visible');
        if (isElementActuallyVisible(visibleOverlay)) return true;

        var visiblePopup = visibleOverlay && visibleOverlay.querySelector('.kaching-popup');
        if (isElementActuallyVisible(visiblePopup)) return true;

        var v2Popup = document.querySelector('kaching-popup-v2');
        if (isElementActuallyVisible(v2Popup)) return true;

        return false;
    }

    function forceRevealKachingPopup() {
        var overlay = document.querySelector('.kaching-overlay.kaching-popup-visible');
        var popup = overlay && overlay.querySelector('.kaching-popup');
        if (!overlay || !popup) return false;

        var text = normalizeText(popup.innerText || popup.textContent || '');
        if (!/decline this offer|yes,\s*i want it|don't forget this/.test(text)) {
            return false;
        }

        try {
            overlay.style.setProperty('display', 'flex', 'important');
            overlay.style.setProperty('opacity', '1', 'important');
            overlay.style.setProperty('visibility', 'visible', 'important');
            overlay.style.setProperty('pointer-events', 'auto', 'important');
            overlay.style.setProperty('position', 'fixed', 'important');
            overlay.style.setProperty('inset', '0', 'important');
            overlay.style.setProperty('z-index', '2147483647', 'important');

            popup.style.setProperty('display', 'block', 'important');
            popup.style.setProperty('opacity', '1', 'important');
            popup.style.setProperty('visibility', 'visible', 'important');
            popup.style.setProperty('pointer-events', 'auto', 'important');
            return true;
        } catch (e) {
            return false;
        }
    }

    async function waitForKachingPopupVisible(timeout) {
        var startedAt = Date.now();
        while (Date.now() - startedAt < timeout) {
            if (isKachingPopupVisible()) return true;
            await sleep(80);
        }
        return isKachingPopupVisible();
    }

    async function waitForKachingPopupTrigger(timeout) {
        var startedAt = Date.now();
        while (Date.now() - startedAt < timeout) {
            if (typeof window.kachingPopupTriggerATC === 'function') {
                return window.kachingPopupTriggerATC;
            }
            await sleep(80);
        }
        return typeof window.kachingPopupTriggerATC === 'function' ? window.kachingPopupTriggerATC : null;
    }

    function clearKachingPopupSuppression() {
        try {
            window.sessionStorage && sessionStorage.removeItem('kachingAddToCartOncePerSessionShown');
        } catch (e) { /* storage can be blocked in some embedded contexts */ }

        try {
            if (window.localStorage) {
                for (var i = localStorage.length - 1; i >= 0; i--) {
                    var key = localStorage.key(i);
                    if (key && key.indexOf('kachingPopupFreq_') === 0) {
                        localStorage.removeItem(key);
                    }
                }
            }
        } catch (e2) { /* storage can be blocked in some embedded contexts */ }
    }

    function goToCheckout() {
        if (_kachingCheckoutBridge.redirecting) return;
        _kachingCheckoutBridge.redirecting = true;
        markCheckoutBridgeNavigation();
        window.location.href = '/checkout';
    }

    function markCheckoutBridgeNavigation() {
        try {
            window.sessionStorage && sessionStorage.setItem(CHECKOUT_RETURN_MARKER_KEY, '1');
        } catch (e) { /* storage can be blocked in some embedded contexts */ }
    }

    function consumeCheckoutBridgeNavigationMarker() {
        try {
            if (!window.sessionStorage || sessionStorage.getItem(CHECKOUT_RETURN_MARKER_KEY) !== '1') return false;
            sessionStorage.removeItem(CHECKOUT_RETURN_MARKER_KEY);
            return true;
        } catch (e) {
            return false;
        }
    }

    function scheduleCheckoutReturnHardReset() {
        if (isCheckoutUrl(window.location.href)) return;
        setTimeout(function () {
            try {
                window.location.reload();
            } catch (e) {
                window.location.href = window.location.href;
            }
        }, 90);
    }

    function closeSmartCartDrawer() {
        try {
            if (window.themeCartDrawer && typeof window.themeCartDrawer.close === 'function') {
                window.themeCartDrawer.close();
            }
        } catch (e) { /* drawer may already be closed */ }
    }

    function clearKachingCheckoutBridgeTimer() {
        if (_kachingCheckoutBridge.timeoutId) {
            clearTimeout(_kachingCheckoutBridge.timeoutId);
            _kachingCheckoutBridge.timeoutId = null;
        }
    }

    function scheduleKachingCheckoutRedirect(delay) {
        if (!_kachingCheckoutBridge.armed) return;
        if (_kachingCheckoutBridge.expiresAt && Date.now() > _kachingCheckoutBridge.expiresAt) {
            _kachingCheckoutBridge.armed = false;
            clearKachingCheckoutBridgeTimer();
            return;
        }
        _kachingCheckoutBridge.armed = false;
        clearKachingCheckoutBridgeTimer();
        setTimeout(function () {
            goToCheckout();
        }, delay);
    }

    function bindKachingCheckoutBridgeEvents() {
        if (_kachingCheckoutBridge.listenersBound) return;
        _kachingCheckoutBridge.listenersBound = true;

        document.addEventListener('popup-declined', function () {
            scheduleKachingCheckoutRedirect(120);
        });
        document.addEventListener('popup-accepted', function () {
            scheduleKachingCheckoutRedirect(2300);
        });
        document.addEventListener('popup-all-accepted', function () {
            scheduleKachingCheckoutRedirect(2600);
        });
        document.addEventListener('popup-with-bundle-accepted', function () {
            scheduleKachingCheckoutRedirect(3000);
        });

        document.addEventListener('kaching-popup-v2:closed', function () {
            scheduleKachingCheckoutRedirect(120);
        });
        document.addEventListener('kaching-popup-v2:add-to-cart-submitted', function () {
            scheduleKachingCheckoutRedirect(2300);
        });
        document.addEventListener('kaching-popup-v2:bundle-add-to-cart-submitted', function () {
            scheduleKachingCheckoutRedirect(3000);
        });
        document.addEventListener('kaching-popup-v2:slider-add-all-to-cart-submitted', function () {
            scheduleKachingCheckoutRedirect(3000);
        });
    }

    function armKachingCheckoutBridge() {
        bindKachingCheckoutBridgeEvents();
        clearKachingCheckoutBridgeTimer();
        _kachingCheckoutBridge.armed = true;
        _kachingCheckoutBridge.expiresAt = Date.now() + 120000;
        _kachingCheckoutBridge.timeoutId = setTimeout(function () {
            _kachingCheckoutBridge.armed = false;
            _kachingCheckoutBridge.timeoutId = null;
        }, 120000);
    }

    function disarmKachingCheckoutBridge() {
        _kachingCheckoutBridge.armed = false;
        _kachingCheckoutBridge.expiresAt = 0;
        clearKachingCheckoutBridgeTimer();
    }

    async function triggerKachingCheckoutPopup() {
        clearKachingPopupSuppression();

        var kachingTrigger = await waitForKachingPopupTrigger(KACHING_TRIGGER_READY_TIMEOUT);
        if (typeof kachingTrigger === 'function') {
            armKachingCheckoutBridge();
            try {
                var triggered = await withTimeout(
                    Promise.resolve(kachingTrigger.call(window)),
                    KACHING_TRIGGER_TIMEOUT,
                    'Kaching popup trigger'
                );
                if (triggered) {
                    var isVisible = await waitForKachingPopupVisible(700);
                    if (!isVisible && forceRevealKachingPopup()) {
                        isVisible = await waitForKachingPopupVisible(500);
                    }
                    if (!isVisible) {
                        isVisible = await waitForKachingPopupVisible(900);
                    }
                }

                if (triggered && isVisible) {
                    closeSmartCartDrawer();
                    return true;
                }
            } catch (err) {
                debugWarn('Kaching popup trigger failed:', err);
            }
            disarmKachingCheckoutBridge();
        }

        var v2Popup = document.querySelector('kaching-popup-v2');
        if (v2Popup && v2Popup.settings && typeof v2Popup.show === 'function') {
            armKachingCheckoutBridge();
            try {
                v2Popup.show();
                if (await waitForKachingPopupVisible(800)) {
                    closeSmartCartDrawer();
                    return true;
                }
            } catch (err2) {
                debugWarn('Kaching popup v2 trigger failed:', err2);
            }
            disarmKachingCheckoutBridge();
        }

        return false;
    }

    // ---- SMART CART DRAWER UPSELL INTERCEPTOR ----
    window.addEventListener('click', function (e) {
        var upsellButton = getSmartCartUpsellButton(e);
        if (!upsellButton) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        addSmartCartUpsellDirect(upsellButton);
    }, true);

    // ---- SMART CART DRAWER CHECKOUT -> KACHING POPUP BRIDGE ----
    window.addEventListener('click', function (e) {
        var checkoutButton = getSmartCartCheckoutButton(e);
        if (!checkoutButton || checkoutButton.disabled || checkoutButton.getAttribute('data-clm-checkout-loading') === '1') return;

        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        checkoutButton.setAttribute('data-clm-checkout-loading', '1');

        triggerKachingCheckoutPopup().then(function (triggered) {
            if (!triggered) {
                goToCheckout();
            }
        }).catch(function (err) {
            debugWarn('Kaching checkout bridge failed:', err);
            goToCheckout();
        }).finally(function () {
            checkoutButton.removeAttribute('data-clm-checkout-loading');
        });
    }, true);

    // ---- BUY NOW / ADD TO CART BUTTON INTERCEPTOR ----
    document.addEventListener('click', async function (e) {
        // GÜVENLİK: SCD drawer Shadow DOM içindeki butonlara dokunma.
        // Drawer'ın checkout butonu Shadow DOM'da; event composedPath ile
        // ana DOM'a bubble ediyor olabilir, bizim selector'umüz yanlışlıkla
        // eşleşmemeli.
        var path = typeof e.composedPath === 'function' ? e.composedPath() : [];
        for (var i = 0; i < path.length; i++) {
            var node = path[i];
            if (node && node.id === 'cart-drawer-shadow-host') return;
            if (node && node.id === 'cart-drawer-container') return;
            if (node && node.tagName && /cart-drawer/i.test(node.tagName)) return;
        }

        var btn = e.target.closest('button.gp-button-atc, button[type="submit"][name="add"]');
        if (!btn) return;
        if (btn.getAttribute('data-state') === 'loading') return;

        var form = btn.closest('form[action*="/cart/add"]');
        if (!form) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        btn.setAttribute('data-state', 'loading');

        try {
            var idInput = form.querySelector('input[name="id"]') || form.querySelector('input[name="variant_id"]');
            var variantId = idInput ? idInput.value : null;
            var quantity = getQuantity(form);
            var properties = getLineItemProperties(form);

            if (!variantId) {
                btn.setAttribute('data-state', 'idle');
                return;
            }

            var smartResult = await addWithSmartCart(variantId, quantity, properties);
            if (smartResult) {
                var selectedVariantId = normalizeVariantIdForSelection(variantId);
                trackMetaAddToCart(smartResult, selectedVariantId, quantity);
                document.dispatchEvent(new CustomEvent('cart:item-added', {
                    bubbles: true,
                    detail: { variant_id: selectedVariantId, quantity: quantity, result: smartResult }
                }));
                btn.setAttribute('data-state', 'idle');
                return;
            }

            var cleanResult = await addWithCleanFetch(variantId, quantity, properties);
            if (cleanResult) {
                trackMetaAddToCart(cleanResult, normalizeVariantIdForSelection(variantId), quantity);
                btn.setAttribute('data-state', 'idle');
                return;
            }

            var fallbackPayload = buildAddPayload(variantId, quantity, properties);
            var fallbackHeaders = {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            };
            fallbackHeaders[CART_DRAWER_INTERNAL_HEADER] = 'internal';
            var fallbackRes = await fetchWithTimeout(window.fetch.bind(window), window.location.origin + '/cart/add.js', {
                method: 'POST',
                headers: fallbackHeaders,
                body: JSON.stringify(fallbackPayload)
            }, CART_REQUEST_TIMEOUT, 'Fallback cart add');
            if (fallbackRes.ok) {
                var fallbackData = await withTimeout(fallbackRes.json(), 2000, 'Fallback cart add JSON');
                trackMetaAddToCart(fallbackData, normalizeVariantIdForSelection(variantId), quantity);
                await syncAfterDirectAdd(window.fetch.bind(window));
            }
        } catch (err) {
            console.error('GP Cart Error:', err);
            scheduleCartOpenRecovery();
        } finally {
            btn.setAttribute('data-state', 'idle');
        }
    }, true);

    // ---- CART EVENT LISTENERS (cart icon count sync) ----
    function getCartDataFromEvent(event) {
        var detail = event && event.detail;
        if (!detail) return null;
        return detail.cart || detail.resource || detail.result || detail.data || detail;
    }

    ['cart:synced', 'cart:item-added', 'cart:item-updated'].forEach(function (eventName) {
        window.addEventListener(eventName, function (event) {
            refreshCartIconCount(getCartDataFromEvent(event));
        });
    });

    ['cart:update', 'cart:updated', 'shopify:cart:update', 'shopify:cart:change'].forEach(function (eventName) {
        document.addEventListener(eventName, function (event) {
            refreshCartIconCount(getCartDataFromEvent(event));
        });
    });

    // ---- INITIAL CART ICON SYNC ----
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            refreshCartIconCount();
        }, { once: true });
    } else {
        refreshCartIconCount();
    }

    window.addEventListener('pageshow', function (event) {
        var navEntry = window.performance && window.performance.getEntriesByType ?
            window.performance.getEntriesByType('navigation')[0] : null;
        var isBackForward = event.persisted ||
            (navEntry && navEntry.type === 'back_forward') ||
            (window.performance && window.performance.navigation && window.performance.navigation.type === 2);
        var returnedFromCheckoutBridge = !isCheckoutUrl(window.location.href) && consumeCheckoutBridgeNavigationMarker();
        if (isBackForward || returnedFromCheckoutBridge) {
            performPageRestoreCleanup('pageshow');
        }
        if (isBackForward && returnedFromCheckoutBridge) {
            scheduleCheckoutReturnHardReset();
        }
    }, true);

})();
